export const models: Record<string, string> = {
  'arecont-rtsp': 'Arecont RTSP',
  'avigilon-rtsp': 'Avigilon RTSP',
  'avtech-rtsp': 'AVTech RTSP',
  'axis-211': 'Axis 211',
  'axis-214': 'Axis 214',
  'axis-215': 'Axis 215',
  'axis-231d': 'Axis 231D',
  'axis-233d': 'Axis 233D',
  'axis-241q-mjpg-encoder': 'Axis 241Q MJPEG Encoder',
  'axis-m1054': 'Axis M1054',
  'axis-m1113': 'Axis M1113',
  'axis-m1114': 'Axis M1114',
  'axis-mjpg': 'Axis MJPG',
  'axis-mjpg-ptz': 'Axis MJPG PTZ',
  'axis-p1344': 'Axis P1344',
  'axis-p3346': 'Axis P3346',
  'axis-p5414': 'Axis P5414',
  'axis-p5512': 'Axis P5512',
  'axis-p5522': 'Axis P5522',
  'axis-p5532': 'Axis P5532',
  'axis-p5534': 'Axis P5534',
  'axis-q1755': 'Axis Q1755',
  'axis-q1921': 'Axis Q1921',
  'axis-q6032': 'Axis Q6032',
  'axis-q6034': 'Axis Q6034',
  'axis-q6035': 'Axis Q6035',
  'axis-q6044': 'Axis Q6044',
  'axis-v5925': 'Axis V5925',
  'axis-rtsp': 'Axis H.264',
  'axis-rtsp-ptz': 'Axis H.264 PTZ',
  'bosh-jpg': 'Bosh JPG',
  'canon-mjpg-ptz': 'Canon MJPG PTZ',
  'canon-rtsp': 'Canon RTSP',
  'canon-rtsp-ptz': 'Canon RTSP PTZ',
  canon2: 'Canon 2 RTSP PTZ',
  'canon-vbc60': 'Canon VB-C60',
  'convision-mjpg': 'Convision MJPG',
  'dahua-rtsp-ptz': 'Dahua RTSP PTZ',
  'faibrasil-rtsp-ptz': 'FAIBrasil RTSP PTZ',
  'ganz-rtsp': 'Ganz RTSP',
  'generic-jpg': 'Generic JPG',
  'generic-mjpg': 'Generic MJPG',
  'generic-rtsp': 'Generic RTSP',
  'hikvision-rtsp': 'Hikvision RTSP',
  'hikvision2-rtsp': 'Hikvision 2 RTSP',
  'hikvision3-rtsp': 'Hikvision 3 RTSP',
  'hikvision4-rtsp': 'Hikvision 4 RTSP',
  'lilin-rtsp': 'Lilin RTSP',
  'lorex-rtsp-ptz': 'Lorex RTSP PTZ',
  'mobotix-mjpg': 'Mobotix MJPEG',
  'panasonic-mjpg': 'Panasonic MJPG',
  'panasonic-rtsp-ptz': 'Panasonic RTSP PTZ',
  'panasonic-wv-mjpg': 'Panasonic WV MJPG',
  'panasonic-wv-rtsp': 'Panasonic WV RTSP',
  'pixord-rtsp': 'Pixord RTSP',
  'samsung-encoder': 'Samsung H.264 Encoder',
  'samsung-rtsp': 'Samsung H.264',
  'samsung-rtsp-ptz': 'Samsung H.264 PTZ',
  'samsung-snb6004': 'Samsung SNB6004',
  'samsung-snp5300': 'Samsung SNP5300',
  'samsung-snz6320n': 'Samsung SNZ6320N',
  'sanyo-rtsp': 'Sanyo RTSP',
  'sony-ipela-rtsp': 'Sony Ipela RTSP',
  'sony-mjpg': 'Sony MJPG',
  'sony-rx550n': 'Sony SNC-RX550N',
  'sony-sncwr630': 'Sony SNC-WR630',
  'sony-sncer585': 'Sony SNC-ER585',
  'sony-sncrz30n': 'Sony SNC-RZ30N',
  'stardot-rtsp': 'Stardot RTSP',
  'toshiba-mjpg-ptz': 'Toshiba MJPG PTZ',
  'videoiq-rtsp': 'VideoIQ RTSP',
  'vivotek-rtsp': 'Vivotek RTSP',
  'wansview-rtsp': 'Wansview RTSP',
};
